export default __webpack_public_path__ + "static/ApercuLAPhil-Regular-9d1636a8afe476b82ccc48aa713d2c1d.woff2";